import { render, staticRenderFns } from "./AttributionTable.vue?vue&type=template&id=544a334e&scoped=true"
import script from "./AttributionTable.vue?vue&type=script&lang=js"
export * from "./AttributionTable.vue?vue&type=script&lang=js"
import style0 from "./AttributionTable.vue?vue&type=style&index=0&id=544a334e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544a334e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('544a334e')) {
      api.createRecord('544a334e', component.options)
    } else {
      api.reload('544a334e', component.options)
    }
    module.hot.accept("./AttributionTable.vue?vue&type=template&id=544a334e&scoped=true", function () {
      api.rerender('544a334e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/teacher/AttributionTable.vue"
export default component.exports